import FilterAttributeMethods from '@ve/components/filters/common/filterMethods/filterAttributeMethods/FilterAttributeMethods';
import { IDistanceLift } from '../types';
import distanceLiftData from './dataDistanceLift';

export default new FilterAttributeMethods<IDistanceLift>(distanceLiftData, 'distanceLift').setFilterName('Расстояние до подъёмника');